import type { ReactNode } from 'react';
import * as st from './styles.module.scss';

type AspectRatio = [number, number];

export interface AspectRatioContentProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: ReactNode;
    className?: string;
    aspect?: AspectRatio;
}

export const AspectRatioContent = ({ children, className, aspect = [16, 9], ...props }: AspectRatioContentProps): JSX.Element => {

    const paddingBottom = `${(100 * (aspect[1] / aspect[0])).toFixed(2)}%`;


    return (
        <div className={`${st.wrapper} ${className}`} style={{ paddingBottom: paddingBottom }} {...props}>
            <div className={st.content}>
                {children}
            </div>
        </div>
    );
};
